const c = {
  name: "Unicorn",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M33.3,24.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C32,23.7,32.6,24.2,33.3,24.2
			z"/>
		<path class="st0" d="M30,23c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C29.4,21.7,30,22.3,30,23z"/>
		<path class="st0" d="M40,11h-4.3L32,0l-2.4,7c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.4,0c-5,0-9,4-9,9h-3v1c0,0.3,0,0.7,0.1,1H17
			c-0.7,0-1.3,0.1-2,0.2V18c0-1.3-0.5-2.6-1.5-3.5c-1-0.9-2.2-1.5-3.5-1.5c-2.8,0-5,2.2-5,5v2H0v1c0,2.4,0.9,4.7,2.6,6.4
			C4.1,28.8,6,29.7,8,29.9V40h7v-6h10v6h7V29.9c1.8-0.2,3.4-1,4.7-2.3c1.5-1.5,2.3-3.5,2.3-5.7c0-1.5-0.4-2.9-1.2-4.2
			c1.4-1.6,2.2-3.6,2.2-5.8V11z M30.4,11L32,6.3l1.6,4.7H30.4z M22.2,18l-0.1-1.1c0-0.3-0.1-0.6-0.1-0.9c0-3.9,3.1-7,7-7l-0.7,2.1
			C25.9,11.4,24,13.5,24,16c0,0.6,0.1,1.1,0.3,1.7C23.5,18.9,23,20.4,23,22c0,0.7,0.1,1.4,0.3,2.1c-2.3-1.2-3.9-3.5-4.2-6.1L22.2,18
			L22.2,18z M4,26c-1.1-1.1-1.8-2.5-2-4H7v-4c0-1.7,1.3-3,3-3c0.8,0,1.6,0.3,2.1,0.9c0.6,0.6,0.9,1.3,0.9,2.1v0.9c0,0,0,0,0,0
			c-0.3,0.1-0.6,0.3-0.9,0.5c0,0-0.1,0-0.1,0.1c0,0-0.1,0-0.1,0.1c-0.3,0.2-0.6,0.4-0.8,0.6c-0.4,0.3-0.8,0.7-1.1,1.1v0
			C8.7,23,8,25,8,27v0.9C6.5,27.7,5.1,27,4,26L4,26z M27,38v-6H13v6h-3V27c0-1.6,0.5-3.1,1.6-4.4c0.2-0.3,0.5-0.6,0.8-0.9
			c0.6-0.5,1.3-1,2-1.2c0.9-0.3,1.7-0.5,2.6-0.5h0.5c1,3.2,3.7,5.8,7.1,6.7c1.3,1.8,3.3,3,5.5,3.2V38H27z M35.2,26.2
			C34.1,27.4,32.6,28,31,28c-2,0-3.9-1-5-2.7c-0.6-1-1-2.1-1-3.3c0-0.9,0.2-1.7,0.5-2.4c0.9,0.9,2.1,1.4,3.5,1.4h2
			c2,0,3.8-0.7,5.3-1.8C36.8,20.1,37,21,37,22C37,23.6,36.4,25.1,35.2,26.2z M31,19h-2c-1.6,0-3-1.4-3-3s1.4-3,3-3h8.9
			C37.4,16.4,34.5,19,31,19z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Unicorn
};
